import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'

const Accelerate = () => {
    return (
        <>
            {/* Accelerate cloud */}
            <section className="accelerate-cloud-three mt-5">
                <div className="container">
                    {/* <div className="shapes-three-left">
                        <ImageWithBasePath
                            className="accelerate-three"
                            src="assets/img/shapes/shape-8.png"
                            alt="Img"
                        />
                        <ImageWithBasePath
                            className="accelerate-five"
                            src="assets/img/shapes/shape-9.png"
                            alt="Img"
                        />
                    </div> */}
                    {/* <div className="section-header-title" data-aos="fade-up">
                        <div className="row align-items-center d-flex justify-content-between">
                            <div className="col-lg-5 col-md-12">
                                <div className="home-five-head mb-4">
                                    <h2 className="text-white">Accelerate Cloud Success </h2>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12">
                                <p className="text-white ms-lg-5 mb-4">
                                    96% of eLearning for Business customers see improved results
                                    within six months. Whether you’re a team of 10 or 10,000, faster
                                    cloud fluency starts here.
                                </p>
                            </div>
                        </div>
                    </div> */}
                    {/* Award Winning */}
                    <div className="award-one">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 h-400 w-300"
                                        src="assets/img/home-5/master-06.jpg"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-9.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/award.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>PROGRAMS</h4>
                                    <h2 className="text-warning my-4">
                                        Unlock 140,000+ Global Study Programs
                                    </h2>
                                    <p className="text-white mb-4">
                                        Search and connect—all in one place. Skip the hassle of managing individual contracts. Match students with top-fit programs, including exclusive options you won’t find anywhere else.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Award Winning */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>RELIABILITY</h4>
                                    <h2 className="text-skyblue my-4">
                                        Boost Your Approval Rate to 95%
                                    </h2>
                                    <p className="text-white mb-4">
                                       Stop gambling with applications. Our AI-driven tools and rigorous quality checks help you hit a 95% success rate—delivering better results for your students and more stable commissions for you.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 h-400 w-300"
                                        src="assets/img/index-4/banner-01.jpg"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/index-3/banner-01.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>INSIGHTS</h4>
                                    <h2 className="text-success my-4">
                                        Stay Ahead with Expert Training and Insights
                                    </h2>
                                    <p className="text-white mb-4">
                                        Stay compliant, competitive, and confident. Access strategic guidance, document verification, and in-depth training to grow your recruitment success with clarity and credibility.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                    {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>SAVINGS</h4>
                                    <h2 className="text-skyblue my-4">
                                        Cut Costs. Save Time. Scale Smarter.
                                    </h2>
                                    <p className="text-white mb-4">
                                       Automate the slow stuff. Our proven tech streamlines applications, eliminates delays, and accelerates your entire workflow—so you can focus on growing your success.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/home-2/master-03.jpg"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                    {/* development-carrer*/}
                    <div className="development-carrer">
                        <div className="row align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1 h-400 w-300"
                                        src="assets/img/home-5/master-03.jpg"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-6.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="ms-lg-5 ps-lg-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/winning.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>RESOURCES</h4>
                                    <h2 className="text-success my-4">
                                        Offer More Than Just Applications
                                    </h2>
                                    <p className="text-white mb-4">
                                        From student loans and GICs to language test vouchers and financial tools—our all-in-one solutions help you support students at every stage and grow your business beyond recruitment.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /development-carrer */}
                     {/* Learn Anything */}
                    <div className="learn-anything">
                        <div className="row align-items-center">
                            <div className="col-xl-7 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="me-5 pe-5">
                                    <div className="mb-3">
                                        <ImageWithBasePath src="assets/img/icon/time.svg" alt="certified" />
                                    </div>
                                    <h4 className='text-pink'>BENEFITS</h4>
                                    <h2 className="text-skyblue my-4">
                                        Unlock Elite Rewards as a Preferred Partner
                                    </h2>
                                    <p className="text-white mb-4">
                                      Earn more, skip the wait, and gain VIP access. Enjoy top-tier commissions, priority support, exclusive events, and powerful growth perks—all through our partner rewards program.
                                    </p>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 col-12" data-aos="fade-up">
                                <div className="master-img mb-0">
                                    {/* <ImageWithBasePath
                                        className="img-fluid master-bg4"
                                        src="./assets/img/bg/shape-04.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-bg5"
                                        src="./assets/img/bg/shape-05.svg"
                                        alt="img"
                                    /> */}
                                    <ImageWithBasePath
                                        className="img-fluid master-bg2"
                                        src="assets/img/shapes/shape-7.svg"
                                        alt="img"
                                    />
                                    <ImageWithBasePath
                                        className="img-fluid master-skill-image1"
                                        src="assets/img/home-5/section-img-03.png"
                                        alt="img"
                                    />
                                    {/* <div className="text-end">
                                        <ImageWithBasePath
                                            className="img-fluid master-skill-image2"
                                            src="assets/img/feature/feature-13.jpg"
                                            alt="img"
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Learn Anything */}
                </div>
            </section>
            {/* Accelerate cloud */}
        </>

    )
}

export default Accelerate
